import { all, Effect } from "redux-saga/effects"
import { Injector } from "../di/Injector"
import { watchSimpleMessageError } from "./sagas/watchSimpleMessageError"
import { watchUnknownError } from "./sagas/watchUnknownError"

export function* error(injector: Injector): Generator<Effect> {
  yield all([watchUnknownError(injector), watchSimpleMessageError()])
}
